import type { ReactNode } from "react";

import { isNative, match } from "@stepapp/core";
import { Block, useBreakpoints } from "@stepapp/ui";

type GridProps = {
  children?: ReactNode;
  columns?: number;
  gap?: number;
  numberOfOptions?: number;
  oneRow?: boolean;
  oneColumn?: boolean;
};

export const Grid = ({
  children,
  columns,
  gap = 0,
  numberOfOptions = 0,
  oneRow = false,
  oneColumn = false,
}: GridProps) => {
  const { lg, sm } = useBreakpoints();

  const defaultColumns = match(true)
    .when(
      () => oneColumn,
      () => 1,
    )
    .when(
      () => oneRow || lg,
      () => numberOfOptions,
    )
    .when(
      () => sm,
      () => 2,
    )
    .otherwise(() => 1);

  return (
    <Block
      style={{
        display: isNative ? "flex" : "grid",
        gridGap: `${gap}px`,
        gridTemplateColumns: `repeat(${columns || defaultColumns}, 1fr)`,
      }}
    >
      {children}
    </Block>
  );
};
